<template>
<div class="work" id="work-8">
	<h2><span>05</span> FX Log</h2>
	<div class="subtitle">
		<h3><span>Year</span>2023</h3>
		<h3><span>Product</span>Website</h3>
		<h3><span>Technology</span>Wordpress / Gsap</h3>
	</div>
	<blockquote>
		FX Log is a Logistic company for the export and import trade clients based in Itajaí, Brazil. They have vast knowledge in the market, being one of the most traditional companies in the region.
	</blockquote>
	<figure class="int">
		<figcaption>
			<h3>Objective for this project</h3>
			<p>Showcase the business services, highlighting the cowork exclusive providing, adding a modern and fresh market position.</p>
			<h3>My Role</h3>
			<p>Generate the designs and develop the website in Wordpress, giving them freedom to control updates and changes needed.</p>
		</figcaption>
		<span><img src="../../assets/Fx-log-Home.jpg" alt="FX log home"></span>
	</figure>
	<figure class="half">
		<figcaption>
			<h3>The Solution</h3>
			<p>Investing with the elements that converge with the business logo, and a great imagery to support the context, I created a sofisticated design with a geometrical style.</p>
			<p>That established the company heavy organization and compromisse with clients and logistics. Also created the visual guideline adopted along many brand materials.</p>
		</figcaption>
		<img src="../../assets/Fx-log-mb-01.jpg" alt="Fx log responsive">
	</figure>
	<figure class="half">
		<figcaption>
			<blockquote>Going from zero to a complete showcase of the business was a great exercise, the special aspect of doing UX design in new fields of market teaches me much.</blockquote> 
		</figcaption>
		
	</figure>
	<figure>
		<span><img src="../../assets/Fx-log-Picking.jpg" alt="FX log picking"></span>
		<span><img src="../../assets/Fx-log-Serviços.jpg" alt="FX log services"></span>
	</figure>
	<blockquote>
		"I'm thrive to stand out how much the business impression with the new website had a positive impact with clients and new leads, they are trusted by the market, see the result <a href="//fx.log.br" target="_blank">fx.log.br</a>"
	</blockquote>
</div>
</template>